import { Box, Typography } from "@mui/material";
import { HeaderStyled } from "./header.styles";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";

interface HeaderType {
  title: string;
  description: string | JSX.Element;
  iscenteraligned?: boolean;
  customCta?: JSX.Element;
  showBackButton?: boolean;
  handleBack?: () => void;
  hideDescription?: boolean | undefined;
}
const Header = ({
  iscenteraligned = false,
  title,
  description,
  customCta,
  showBackButton,
  handleBack,
  hideDescription,
}: HeaderType) => {
  return (
    <HeaderStyled iscenteraligned={iscenteraligned} hideDescription={hideDescription}>
      {customCta ? (
        <Box className="custom-content">
          <Box className="title-wrapper">
            <Box className="title-back-wrapper">
              {showBackButton && (
                <span onClick={handleBack} className="back-icon">
                  <ArrowBackIcon />
                </span>
              )}
              <Typography className="title" variant="h1">
                {title}
              </Typography>
            </Box>
            {description && (
              <Typography className="description">{description}</Typography>
            )}
          </Box>
          <Box className="cta-wrapper">{customCta}</Box>
        </Box>
      ) : (
        <Box className="title-wrapper">
          <Box className="title-back-wrapper">
            {showBackButton && (
              <span onClick={handleBack} className="back-icon">
                <ArrowBackIcon />
              </span>
            )}
            <Typography className="title" variant="h1">
              {title}
            </Typography>
          </Box>
          {description && (
            <Typography className="description">{description}</Typography>
          )}
        </Box>
      )}
    </HeaderStyled>
  );
};

export default Header;
